<template>
  <el-row :gutter="24">
    <el-col
      v-if="showMarketingPosts"
      :xs="24"
      :sm="24"
      :md="24"
      :lg="8"
      :xl="8"
    >
      <Info
        :block-title="marketingPostsData.blockTitle"
        :items="marketingPostsData.items"
      />
    </el-col>
    <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
      <Faq />
    </el-col>
    <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
      <Info :block-title="helpData.blockTitle" :items="helpData.items" />
    </el-col>
  </el-row>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useMarketingPosts } from '@/hooks/useMarketingPosts'
import Info from './cards/Info.vue'
import Faq from './cards/Faq.vue'

export default defineComponent({
  name: 'DirectFaq',
  components: {
    Faq,
    Info
  },
  setup() {
    const marketingPosts = useMarketingPosts()

    const marketingPostsData = computed(() => ({
      blockTitle: marketingPosts.blockTitle,
      items: marketingPosts.items.value
    }))

    const showMarketingPosts = computed(() => {
      return marketingPosts.show.value
    })

    const helpData = {
      blockTitle: 'Help center',
      items: [
        {
          url: 'https://support.traforama.com/en/collections/getting-started',
          title: 'Getting started',
          description: 'Set up your first campaign'
        },
        {
          url: 'https://support.traforama.com/en/collections/traffic-sources',
          title: 'Traforama traffic sources',
          description: 'Ad formats, domains, and marketplace'
        },
        {
          url: 'https://support.traforama.com/en/collections/useful-tips-reporting',
          title: 'Useful tips & reporting',
          description: 'Expert tips and statistics'
        },
        {
          url: 'https://support.traforama.com/en/collections/pricing-and-cpm-rates',
          title: 'Pricing and CPM rates',
          description: 'CPM rates and bidding strategies'
        }
      ]
    }

    return { helpData, showMarketingPosts, marketingPostsData }
  }
})
</script>
<style lang="scss" scoped>
.el-row {
  margin-top: 10px;
}

.el-col {
  margin-top: 24px;
}
:deep(.el-card) {
  height: 100%;
}
:deep(.el-card__header) {
  padding: 24px;
  border: none;
  h3 {
    font-size: 18px;
    margin: 0;
  }
}
:deep(.el-card__body) {
  padding: 0 24px 24px;
}
</style>
